import React, { useEffect } from 'react';
import { Button, Dropdown, Input, Item, Modal } from 'semantic-ui-react';
import { connect } from 'react-redux';
import * as actions from '../../../redux/actions';
import * as selectors from '../../../redux/selectors';
import { bindActionCreators } from 'redux';
import NumberFormat from 'react-number-format';
import './SelectListingModal.scss';

const SelectListingModal = ({ formik, slot, listings, trigger, getItemsForFirms }) => {
  const [open, setOpen] = React.useState(false);
  const [selected, setSelected] = React.useState([]);
  const [results, setResults] = React.useState([]);

  const handleSubmit = () => {
    formik.setFieldValue('itemIds', selected);
    setOpen(false);
  };

  useEffect(() => setResults(listings), [listings]);

  const handleSelect = listing => {
    if (isSelected(listing)) {
      return setSelected(selected.filter(id => id !== listing.id));
    }
    setSelected([...selected, listing.id]);
  };

  const isSelected = listing => {
    return Boolean(selected.find(id => id === listing.id));
  };

  const handleOpen = () => {
    setSelected([...slot.itemIds]);
    setOpen(true);
  };

  const isMatch = (item, query) => {
    return Object.keys(item)
      .filter(key => item[key])
      .map(key => item[key] && item[key].toString().toUpperCase().includes(query.toUpperCase()))
      .some(item => item);
  };

  const handleSearch = e => {
    const query = e.target.value.trim();
    if (!query) {
      setResults(listings);
    } else {
      const filtered = Object.keys(listings)
        .map(key => listings[key])
        .filter(item => isMatch(item, query));

      const grouped = filtered.reduce((prev, curr) => {
        prev[curr.id] = curr;
        return prev;
      }, {});

      setResults(grouped);
    }
  };

  const getPage = () => (
    <Modal
      size="large"
      closeIcon
      onClose={() => setOpen(false)}
      onOpen={handleOpen}
      open={open}
      trigger={trigger ? trigger : <Dropdown.Item icon="star outline" text="Add listings" />}
    >
      <Modal.Header>Select listings</Modal.Header>
      <Modal.Content scrolling className="select-listing-modal">
        <Input icon="search" placeholder="Search listings..." onChange={handleSearch} />

        <Item.Group divided className="listing-item-group">
          {Object.keys(results)
            .map(key => results[key])
            .filter(item => item)
            .map((listing, idx) => (
              <Item key={idx} onClick={() => handleSelect(listing)}>
                <Item.Image
                  size="small"
                  src={listing.imageUrl}
                  label={isSelected(listing) ? { as: 'a', corner: 'left', icon: 'check', color: 'green' } : false}
                />
                <Item.Content className="listing-body">
                  <Item.Header>{listing.description1}</Item.Header>
                  <Item.Description>
                    <Item.Description>{listing.address}</Item.Description>
                    <Item.Description>{listing.description2}</Item.Description>
                    <Item.Meta>
                      <NumberFormat
                        value={listing.price}
                        displayType={'text'}
                        thousandSeparator={true}
                        prefix={'$'}
                        renderText={(value, props) => <div {...props}>{value}</div>}
                      />
                    </Item.Meta>
                  </Item.Description>
                </Item.Content>
              </Item>
            ))}
        </Item.Group>
      </Modal.Content>
      <Modal.Actions>
        <Button color="black" onClick={() => setOpen(false)}>
          Cancel
        </Button>
        <Button content="Save" labelPosition="left" icon="save" onClick={handleSubmit} positive />
      </Modal.Actions>
    </Modal>
  );

  return <>{listings && getPage()}</>;
};

const mapStateToProps = state => ({
  listings: selectors.getItemsForFirms(state),
});

const mapDispatchToProps = dispatch => ({
  updateCurrentAdSlotItems: bindActionCreators(actions.adSlot.updateCurrentAdSlotItems, dispatch),
  addListing: bindActionCreators(actions.listing.addListing, dispatch),
  getItemsForFirms: bindActionCreators(actions.adSlot.getItemsForFirms, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(SelectListingModal);
